module.exports = __webpack_public_path__ + "static/media/startmessage.68e518a7.png";